import Vue from "vue";

Vue.mixin({
    methods: {
        getCurrentLocation() {
            return new Promise((resolve) => {
                this.showLoading();
                navigator.geolocation.getCurrentPosition(
                    position => {
                        this.hideLoading();
                        if (position && position.coords) {
                            resolve({
                                latitude: position.coords.latitude,
                                longitude: position.coords.longitude
                            });
                        } else {
                            resolve(null);
                        }
                    },
                    error => {
                        this.hideLoading();
                        console.log(error);
                        resolve(null);
                    },
                )
            }
            );
        }
    }
});


// WEBPACK FOOTER //
// ./src/mixins/location-handling.js